import React from 'react'
import { Modal, Menu, List, Tooltip, Checkbox, message } from 'antd'
import { app, use, api } from 'xadmin'

import { Icon } from 'xadmin-ui'

const BatchDeleteBtn = props => {
  const { _t } = app.context
  const [show, setShow] = React.useState(false)
  const { canDelete, onBatchDelete } = use('actons.batch_delete', props)
  const { selected, onSelectAll } = use('model.select', props)
  const { model, modelDispatch } = use('model', props)
  const { getItems } = use('model.getItems')
  const [hasAttachment, setHasAttachment] = React.useState()

  const resource = model.resource || model.name
  const onDelete = () => {
    if (hasAttachment) {
      selected.map((item, index) => {
        api({ name: `${resource}/${item.id}?attachment=true` })
          .fetch('', { method: 'DELETE' })
          .then(({ status }) => {
            if (status == 200) {
              message.success('删除成功！')
              onSelectAll(false)
            }
            setShow(false)
            getItems()

          })
          .catch(err => message.error(err.message,err?.detail))
      })
    } else {
      onBatchDelete().then(onClose)
    }

  }
  const onClose = () => {
    setShow(false)
  }
  let newObj = {}
  let obj = model.properties
  Object.keys(obj).forEach(item => {
    if (obj[item].hasOwnProperty('fieldType') && (obj[item].fieldType === 'attachments' || obj[item].fieldType === 'attachment')) {
      newObj[item] = obj[item]
    }
  })
  const attachmentList = !_.isEmpty(newObj) ? _.filter(selected, (v, k) => v && _.keys(newObj)?.indexOf(k) > -1) : null
  const title = (attachmentList !== null ?
    <>
      <p>记录删除后无法恢复，请谨慎操作！</p>
      <Tooltip title="当前记录有附件信息，可以选择级联删除媒体库中的源文件，删除后所有应用该媒体文件的地方均会失效">
        <Checkbox onChange={(e) => setHasAttachment(e.target?.checked)}>删除媒体库源文件</Checkbox>
      </Tooltip>
    </>
    : <>
      <p>记录删除后无法恢复，请谨慎操作！</p>
    </>
  )

  const renderModel = () => {
    return (
      <Modal
        key="actions_batch_delete_modal"
        title={_t('Confirm to delete selected items')}
        visible={show}
        onOk={onDelete}
        okText={_t('Delete')}
        okType="danger"
        cancelText={_t('Cancel')}
        onCancel={onClose}
        bodyStyle={{ maxHeight: 450, overflow: 'auto' }}
      >
        <List
          header={title}
          dataSource={selected}
          renderItem={item => (<List.Item key={item.id}><Icon name={model.icon} /> {model.display ? model.display(item) : item.name}</List.Item>)}
        />
      </Modal>
    )
  }

  return canDelete ? [(
    <Menu.Item {...props} key={'actions_batch_delete'}
      onClick={(e) => {
        props.onClick && props.onClick(e)
        setShow(true)
        setHasAttachment(false)
      }} disabled={selected.length == 0}>
      {_t('Batch Delete Items')}
    </Menu.Item>
  ),
  selected.length > 0 ? renderModel() : null
  ] : null

}

export default BatchDeleteBtn